import PropTypes from 'prop-types';
import styled from 'styled-components';
import {grey} from './color';

export const Span = styled.span`
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
    color: ${({sub}) => sub ? grey.grey300 : grey.grey000};
`;
Span.displayName = 'Span';
Span.propTypes = {
    sub: PropTypes.bool
};

export const SpanLarge = styled(Span)`
    font-size: 16px;
`;
SpanLarge.displayName = 'SpanLarge';
SpanLarge.propTypes = {
    sub: PropTypes.bool
};

export const P = styled.p`
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
    color: ${({sub}) => sub ? grey.grey300 : grey.grey000};
    ${({withMargin}) => withMargin ? `
      margin-bottom: 16px;
    ` : ''};
`;
P.displayName = 'P';
P.propTypes = {
    sub: PropTypes.bool,
    withMargin: PropTypes.bool
};

export const PLarge = styled(P)`
    font-size: 16px;
`;
PLarge.displayName = 'PLarge';
PLarge.propTypes = {
    sub: PropTypes.bool
};

export const Div = styled.div`
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
    font-weight: ${({bold}) => bold ? 'bold' : 'normal'};
    color: ${({sub}) => sub ? grey.grey300 : grey.grey000};
`;
Div.displayName = 'Div';
Div.propTypes = {
    sub: PropTypes.bool,
    bold: PropTypes.bool
};

export const DivLarge = styled(Div)`
    font-size: 16px;
`;
DivLarge.displayName = 'DivLarge';
DivLarge.propTypes = {
    sub: PropTypes.bool
};
